import { useEffect, useRef, useState } from "react";

interface CarouselProps {
  images: string[];
  interval?: number;
}

// const ArrowButton: React.FC<{
//   direction: "prev" | "next";
//   onClick: () => void;
// }> = ({ direction, onClick }) => (
//   <button
//     className="absolute top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 w-12 h-12 rounded-full flex items-center justify-center text-gray-800 transition-all duration-200 z-10"
//     onClick={onClick}
//     aria-label={`${direction === "prev" ? "Previous" : "Next"} slide`}
//   >
//     <i
//       className={`fas fa-chevron-${direction === "prev" ? "left" : "right"}`}
//     ></i>
//   </button>
// );

const DotIndicator: React.FC<{
  active: boolean;
  onClick: () => void;
}> = ({ active, onClick }) => (
  <button
    className={`w-2 h-2 rounded-full transition-all duration-200 ${
      active ? "bg-blue-400" : "bg-white bg-opacity-50"
    }`}
    onClick={onClick}
    aria-label="Go to slide"
  ></button>
);

const ControlButton: React.FC<{ icon: string; onClick: () => void }> = ({
  icon,
  onClick,
}) => (
  <button
    className="bg-white bg-opacity-80 hover:bg-opacity-100 w-10 h-10 rounded-full flex items-center justify-center text-gray-800 transition-all duration-200"
    onClick={onClick}
    aria-label={`Toggle ${icon === "pause" ? "autoplay" : "fullscreen"}`}
  >
    <i className={`fas fa-${icon}`}></i>
  </button>
);

const Carousel: React.FC<CarouselProps> = ({ images, interval = 4000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // 开始自动播放
  const startAutoPlay = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);
  };

  // 停止自动播放
  const stopAutoPlay = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  // 切换自动播放状态
  // const toggleAutoPlay = () => {
  //   if (isAutoPlaying) {
  //     stopAutoPlay();
  //   } else {
  //     startAutoPlay();
  //   }
  //   setIsAutoPlaying(!isAutoPlaying);
  // };

  // 切换全屏模式
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  // 跳转到指定幻灯片
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    if (!isAutoPlaying) startAutoPlay();
  };

  // 下一张幻灯片
  // const nextSlide = () => {
  //   setCurrentIndex((prev) => (prev + 1) % images.length);
  //   if (!isAutoPlaying) startAutoPlay();
  // };

  // 上一张幻灯片
  // const prevSlide = () => {
  //   setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  //   if (!isAutoPlaying) startAutoPlay();
  // };

  // 组件挂载时启动自动播放
  useEffect(() => {
    if (isAutoPlaying) startAutoPlay();
    return () => stopAutoPlay();
  }, []);

  // 当currentIndex改变时重置定时器
  useEffect(() => {
    if (isAutoPlaying) startAutoPlay();
  }, [currentIndex]);

  return (
    <div className="relative w-full max-w-4xl mx-auto">
      {!isFullscreen && (
        <div className="relative w-full aspect-video rounded-lg  shadow-lg">
          {/* 幻灯片容器 */}
          <div
            className="flex transition-transform duration-500 ease-in-out h-auto"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((image, index) => (
              <div key={index} className="min-w-full h-auto">
                <img
                  src={image}
                  className="w-full h-auto object-contain"
                  referrerPolicy="no-referrer"
                  onClick={() => toggleFullscreen()}
                />
              </div>
            ))}
          </div>

          {/* 左右箭头 */}
          {/* <ArrowButton direction="prev" onClick={prevSlide} />
          <ArrowButton direction="next" onClick={nextSlide} /> */}

          {/* 全屏按钮 */}
          {/* <div className="absolute top-4 right-16 flex space-x-2">
            <ControlButton icon="expand" onClick={toggleFullscreen} />
          </div> */}

          {/* 指示点 */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, index) => (
              <DotIndicator
                key={index}
                active={index === currentIndex}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      )}

      {/* 全屏模态框 */}
      {isFullscreen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={(e) => {
            // 如果点击的是背景而不是图片，则退出全屏
            if (e.target === e.currentTarget) {
              toggleFullscreen();
            }
          }}
        >
          <div className="relative w-full h-full max-w-4xl max-h-screen">
            <button
              className="absolute top-4 right-4 text-white text-2xl z-10"
              onClick={toggleFullscreen}
              aria-label="Close fullscreen"
            >
              <i className="fas fa-times"></i>
            </button>

            <div className="w-full h-full flex items-center justify-center">
              <img
                src={images[currentIndex]}
                referrerPolicy="no-referrer"
                className="max-w-full max-h-full object-contain"
              />
            </div>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <DotIndicator
                  key={index}
                  active={index === currentIndex}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Carousel;
